import React, { Component } from 'react';
import { connect } from 'shalala';
import * as qs from 'query-string';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col, Form } from 'react-bootstrap';

import { useStore } from '../../../store';
import { FormControl } from '../../../facturotopia';
import EmisorCsdForm from './components/EmisorCsdForm';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import EmisorSeriesManager from './components/EmisorSeriesManager';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseError from '../../../shared/responses/ResponseError';
import ResponseResult from '../../../shared/responses/ResponseResult';
import EmisorUpsertFiscalInfo from './components/EmisorUpsertFiscalInfo';

class EmisorSectorPrimarioAdquirienteRegistration extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = props.match.params;
    const { data = {}, tenancy } = props;

    this.state = {
      id,
      data: data,
      steps: {
        csd: false,
        fiscal_info: false,
      },
    };

    if (tenancy) {
      props.upsertActions.setPartialState({ tenancy });
    }

    const query = qs.parse(props.location.search);

    if (query.t === 'l') {
      props.upsertActions.setPartialState({ tenancy: 'fa/live' });
    }

    props.upsertActions.setPartialState(this.state);
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsertActions.setPartialState({
        error: undefined,
        __action: action,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    if (!!this.props.onComplete) {
      this.props.onComplete();
    }
  };

  handleOnConfirm = async () => {
    const { id } = this.state;
    const {
      data,
      data: { certificados = {}, direccion = {} },
    } = this.props.upsert;
    const keys = Object.keys(data);

    let info = {};

    for (const key of keys) {
      if (data[key] !== null) {
        info[key] = data[key];
      }
    }

    const certificates = {
      csd_key: certificados.csd_key && certificados.csd_key.value.content,
      csd_cer: certificados.csd_cer && certificados.csd_cer.value.content,
      csd_password: certificados.csd_password,
      fiel_key: certificados.fiel_key && certificados.fiel_key.value.content,
      fiel_cer: certificados.fiel_cer && certificados.fiel_cer.value.content,
      fiel_password: certificados.fiel_password,
    };

    const body = {
      id: id ? undefined : data.id,
      RegistroPatronal: undefined,
      ...info,
      certificados: certificates,
      config: {
        mostrar_direccion_en_pdf: !!data.direccion.direccion,
      },
      adquiriente: true,
      direccion: direccion,
      nomina: {
        RegistroPatronal: data.RegistroPatronal,
      },
    };

    await this.props.upsertActions.upsert(body, id);

    const { result } = this.props.upsert;

    if (!!result && this.props.onComplete) {
      this.props.onComplete(result);
    }
  };

  handleOnDataChange = (event) => {
    let newEvent = {
      ...event,
      steps: {
        ...this.props.upsert.steps,
        [event.step]: event.isValid,
      },
    };

    this.props.upsertActions.setStepDataChange(newEvent);
  };

  handleOnSeriesChange = (event) => {
    const { data, ...rest } = event;

    this.props.upsertActions.setStepDataChange({
      ...this.props.upsert,
      ...rest,
      data: {
        ...this.props.upsert.data,
        ...data,
      },
    });
  };

  handleCustomSeriesCheckboxOnChange = (event) => {
    const { name, checked } = event.target;

    this.setState({
      [name]: checked,
    });

    this.props.upsertActions.setStepDataChange({
      ...this.props.upsert,
      data: {
        ...this.props.upsert.data,
        series: checked ? [] : undefined,
      },
    });
  };

  handleOnChangeCustom = (value) => {
    this.props.upsertActions.setPartialState({
      data: {
        ...this.props.upsert.data,
        ...value,
      },
    });
  };

  handleOnResetClick = () => {
    this.handleOnDataChange({
      data: {
        certificados: {},
        direccion: {},
      },
      isValid: false,
      step: 'csd',
    });
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title="Registro completado"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { id, series_management } = this.state;
    const {
      steps,
      data = {},
      data: { series = [] },
      error,
      result,
      isValid,
      busy,
      fetching,
    } = this.props.upsert;

    const { onComplete } = this.props;

    if (fetching) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}

        {!!result && !onComplete && this.renderResult()}

        <Row>
          <Col xs="12">
            <div className="py-3">
              <strong className="text-info">PERSONALIZAR EMISOR</strong>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            sm={12}
            md={10}
            lg={10}
          >
            <FormControl
              type="text"
              label="Id del emisor"
              name="id"
              placeholder="xxxxxxxx-xxxx-zxxx-yxxx-xxxxxxxxxxxx"
              help="UUID del emisor en el sistema"
              value={data.id}
              rules={['string', 'min:36']}
              onChange={this.handleOnChangeCustom}
            />
          </Col>
        </Row>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={10}
            lg={10}
          >
            <div className="py-3">
              <strong className="text-info">CERTIFICADO DE SELLO DIGITAL (CSD)</strong>
            </div>

            <div className="pb-3">
              <p>
                Derivado de que tu solicitud se relaciona con obligaciones fiscales o emisión de comprobantes
                electrónicos, es necesario que otorgues tus datos fiscales y tu consentimiento para emplearlos al
                solicitar al proveedor del bien o servicio la emisión de tus comprobantes.
              </p>

              <EmisorCsdForm
                data={data}
                onFormDataChange={this.handleOnDataChange}
              />
            </div>

            {steps.csd && (
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                onClick={this.handleOnResetClick}
              >
                Cambiar CSD
              </Button>
            )}
          </Col>
        </Row>

        {steps.csd && (
          <EmisorUpsertFiscalInfo
            data={data}
            onDataChange={this.handleOnDataChange}
          />
        )}

        {steps.csd && (
          <Row>
            <Col
              xs={12}
              sm={12}
              md={10}
              lg={10}
            >
              <div className="py-3">
                <strong className="text-info">SERIES</strong>
              </div>

              <Form.Group controlId="series_management">
                <Form.Check
                  type="checkbox"
                  name="series_management"
                  label="Quiero personalizar las series de este emisor."
                  checked={series_management || false}
                  onChange={this.handleCustomSeriesCheckboxOnChange}
                />
              </Form.Group>

              {series_management && (
                <EmisorSeriesManager
                  data={series || []}
                  step={{}}
                  onFormDataChange={this.handleOnSeriesChange}
                />
              )}
            </Col>
          </Row>
        )}

        {steps.fiscal_info && (
          <Row>
            <Col
              xs={12}
              sm={12}
              md={6}
              lg={5}
              className="py-3"
            >
              <PopConfirm
                text="Realmente deseas cancelar?"
                onAction={this.handleOnAction}
              >
                <Button
                  type="button"
                  variant="secondary"
                  disabled={busy}
                  className="mr-2"
                >
                  Cancelar
                </Button>
              </PopConfirm>

              <LoadingButton
                type="button"
                disabled={!isValid}
                loading={busy || false}
                onClick={this.handleOnConfirm}
              >
                {busy === true ? (!id ? 'Registrando...' : 'Actualizando...') : !id ? 'Registrar' : 'Actualizar'}
              </LoadingButton>
            </Col>
          </Row>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { upsert: store.app.emisores.upsert };
};

const mapActions = (actions) => {
  return { upsertActions: actions.app.emisores.upsert };
};

export default withRouter(connect(useStore, mapState, mapActions)(EmisorSectorPrimarioAdquirienteRegistration));
